import BaseModel from "./base/baseModel";

export default class JanelaColetaModel extends BaseModel {
    id?: number = null;
    franquiaId?: number = null;
    descricao: string = null;
    localEntregaId: number = null;
    localEntregaDescricao: string = null;
    horarioLimite: Date = new Date();
    horarioLimiteString: string = null;
}
